// Shipping calculator — bracket-based, no free shipping.
// Below MOQ (< 5 items) checkout is disabled and shipping cost is N/A.

export const MOQ = 5;

export const SHIPPING_BRACKETS = [
  { min: 5,   max: 9,    cost: 90 },
  { min: 10,  max: 20,   cost: 140 },
  { min: 21,  max: 50,   cost: 190 },
  { min: 51,  max: 100,  cost: 260 },
  { min: 101, max: 200,  cost: 320 },
  { min: 201, max: 500,  cost: 420 },
  { min: 501, max: 700,  cost: 490 },
  { min: 701, max: 1000, cost: 900 },
];

export const calculateShippingCost = (totalQty = 0) => {
  if (totalQty < MOQ) {
    return {
      cost: null,
      free: false,
      belowMoq: true,
      breakdown: `Add ${MOQ - totalQty} more item${MOQ - totalQty === 1 ? "" : "s"} (MOQ ${MOQ})`,
    };
  }
  const bracket =
    SHIPPING_BRACKETS.find((b) => totalQty >= b.min && totalQty <= b.max) ||
    SHIPPING_BRACKETS[SHIPPING_BRACKETS.length - 1];
  return {
    cost: bracket.cost,
    free: false,
    belowMoq: false,
    breakdown: `${bracket.min}–${bracket.max} items tier`,
  };
};

// Add N business days (skip Sat/Sun). N=0 returns the same day if weekday.
const addBusinessDays = (start, n) => {
  const d = new Date(start);
  let added = 0;
  while (added < n) {
    d.setDate(d.getDate() + 1);
    const day = d.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  if (n === 0) {
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
    }
  }
  return d;
};

const DAY_NAMES = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];
const MONTH_NAMES = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

const formatDay = (d) => `${DAY_NAMES[d.getDay()]} ${d.getDate()}`;
const formatDayWithMonth = (d) => `${DAY_NAMES[d.getDay()]} ${MONTH_NAMES[d.getMonth()]} ${d.getDate()}`;

// Returns delivery window: today + 2..3 business days
export const calculateDeliveryWindow = (now = new Date()) => {
  const earliest = addBusinessDays(now, 2);
  const latest = addBusinessDays(now, 3);
  const sameMonth = earliest.getMonth() === latest.getMonth();
  return {
    earliest,
    latest,
    label: sameMonth
      ? `${formatDay(earliest)} – ${formatDay(latest)}`
      : `${formatDayWithMonth(earliest)} – ${formatDayWithMonth(latest)}`,
  };
};
